// extracted by mini-css-extract-plugin
export var modal = "_kk-0";